
import React from "react"

const LayoutContainer = ({ 
  children, //Le contenu encadré par le composant
  border, //Bordure 
  noPaddingBottom, //Pas de padding bottom 
 }) => {


  return (
<div className= {`container mx-auto ${border ? 'border-t border-solid' : ''} ${noPaddingBottom? 'pt-8' : 'py-4 md:py-16 '} `}>
  {children}
  </div>
  )
}
export default LayoutContainer
